import React from 'react'
import mcDonalds from './assets/McDonalds_all_yellow.png'

export function McDonaldsLogo() {
    return <img src={mcDonalds} alt="McDonald's" />
}

export default McDonaldsLogo
